import { RouteConfig, SideLink } from '@/types/utility.types'
import { IconBrandProducthunt } from '@tabler/icons-react'

export const productsModuleKey = 'product'
// export const productVariantModuleKey = 'product_variants'
export const productVariantModuleKey = 'product'

const productList: RouteConfig = {
  uid: productsModuleKey,
  path: '/product-list',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/products')).default,
  }),
}
const productCreate: RouteConfig = {
  uid: productsModuleKey,
  path: '/product-list/create',
  type: 'create',
  lazy: async () => ({
    Component: (await import('@/pages/products/create-product')).default,
  }),
}

const productEdit: RouteConfig = {
  uid: productsModuleKey,
  type: 'update',
  path: '/product-list/edit-product/:productId',
  lazy: async () => ({
    Component: (await import('@/pages/products/edit-product')).default,
  }),
}

const addProductVariant: RouteConfig = {
  uid: productVariantModuleKey,
  type: 'update',
  path: '/product-list/edit-product/:productId/add-variant',
  lazy: async () => ({
    Component: (
      await import('@/pages/products/edit-product/variation/add-variation')
    ).default,
  }),
}

const editProductVariant: RouteConfig = {
  uid: productVariantModuleKey,
  type: 'update',
  path: '/product-list/edit-product/:productId/edit-variant/:variantId',
  lazy: async () => ({
    Component: (
      await import('@/pages/products/edit-product/variation/edit-variant')
    ).default,
  }),
}

export const sidelink: SideLink = {
  uid: productsModuleKey,
  title: 'Products',
  href: '/product-list',
  order: 4,
  icon: <IconBrandProducthunt size={18} />,
}

export default [
  productList,
  productCreate,
  productEdit,
  addProductVariant,
  editProductVariant,
]
